import { useQuery } from 'react-query';
import { fetchStaff } from './staff-api';
import { UserStaff } from './staff-types';

export const QUERY_KEY_STAFF = 'staff';
export const useFetchStaff = () => {
  const { data, ...rest } = useQuery<UserStaff[]>(QUERY_KEY_STAFF, fetchStaff, {
    refetchOnWindowFocus: false,
    //https://github.com/tannerlinsley/react-query/issues/2868#issuecomment-962448442
    staleTime: 5000,
  });

  return {
    staff: data ?? [],
    ...rest,
  };
};
